import { render, staticRenderFns } from "./AffiliateBusiness.vue?vue&type=template&id=6018233a&scoped=true"
import script from "./AffiliateBusiness.vue?vue&type=script&lang=js"
export * from "./AffiliateBusiness.vue?vue&type=script&lang=js"
import style0 from "./AffiliateBusiness.vue?vue&type=style&index=0&id=6018233a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6018233a",
  null
  
)

export default component.exports